//import { ToastProgrammatic as Toast } from 'buefy'
import store from '../store'
import moment from 'moment'
import holiday from '@holiday-jp/holiday_jp';

class Utils {
	constructor(isDebug) {
		this.isDebug = isDebug;
	}

	log(str) {
		if (this.isDebug === 'true') {
			console.log(str);
		}
	}

	/*
	_toast(msg, type) {
		Toast.open({
			duration: 3000,
			position: 'is-top',
			type: type,
			message: msg,
		});
	}

	toastSuccess(msg) {
		this._toast(msg, 'is-success');
	}

	toastError(msg) {
		this._toast(msg, 'is-danger');
	}
	*/

	toCamelCase(str) {
		return str.split('_').map(function(word,index){
			if (index === 0) {
				return word.toLowerCase();
			}
			return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
		}).join('');
	}

	zeroPadding(num, digit) {
		let pad = '';
		for (let i = 0; i < digit; i++) {
			pad += '0';
		}
		return (pad + num).slice(-digit);
	}

	hasError(errors, key) {
		return errors[key] !== '';
	}

	extractFileExtension(fileName) {
		let tmp = fileName.split('.');
		return tmp[tmp.length - 1];
	}

	createCsvContents(data, delim = ',', isQuote = false) {
		let csv = '\ufeff';

		for (let row in data) {
			let line = '';
			for (let col in data[row]) {
				if (!isQuote) {
					line += data[row][col] + delim;
				} else {
					line += `"${data[row][col]}"${delim}`;
				}
			}
			line = line.slice(0, -1);
			csv += line + '\n';
		}

		return csv;
	}

	downloadCSV(data, year, month, fileName, isQuote = false) {
		let csv = this.createCsvContents(data, ',', isQuote);
		let blob = new Blob([csv], { type: 'text/csv' })
		let link = document.createElement('a')
		link.href = window.URL.createObjectURL(blob)
		link.download = fileName
		link.click()
	}

	convertToHhalfWidthCharacter(str) {
		return str.replace(/[０-９]/g, function(s) {
			return String.fromCharCode(s.charCodeAt(0) - 65248);
		})
		.replace(/[‐－―]/g, '-');
	}

	isObject(obj) {
		return Object.prototype.toString.call(obj) === "[object Object]";
	}

	getHostName() {
		let url = new URL(location.href);
		//this.log(url.host);
		//this.log(url.origin);
		return url.origin;
	}

	isSp() {
		return store.state.innerWidth > 768 ? false : true;
	}

	replaceSpBr(str) {
		let reg = new RegExp(/:br/, 'g');
		return str.replace(reg, '<br class="_sp">');
	}

	convertToJpDateTimeFormat(date, time) {
		return moment(date + ' ' + time).format('YYYY年MM月DD日 HH時mm分');
	}

	nl2br(str) {
		return str.replace(/\r?\n/g, '<br>');
	}

	isWeekEndHoliday(date, offset = 0) {
		date = moment(date).add(offset, 'd').format('YYYY-MM-DD');
		return this.isHoliday(date) || this.isWeekEnd(date) ? true : false;
	}

	isWeekEnd(date) {
		let myDate = new Date(date);
		return myDate.getDay() == 6 || myDate.getDay() == 0;
	}

	isHoliday(date) {
		let others = [
			'2022-01-03',
			'2022-01-10',
			'2022-02-11',
			'2022-02-23',
			'2022-03-21',
			'2022-04-29',
			'2022-05-03',
			'2022-05-04',
			'2022-05-05',
			'2022-07-18',
			'2022-08-11',
			'2022-08-15',
			'2022-08-16',
			'2022-09-19',
			'2022-09-23',
			'2022-10-10',
			'2022-11-03',
			'2022-11-23',
			'2022-12-30',
			'2022-12-31',
			'2023-01-01',
			'2023-01-02',
			'2023-01-03',
			'2023-01-09',
			'2023-02-11',
			'2023-02-23',
			'2023-03-21',
			'2023-04-29',
			'2023-05-03',
			'2023-05-04',
			'2023-05-05',
			'2023-07-17',
			'2023-08-11',
			'2023-08-14',
			'2023-08-15',
			'2023-08-16',
			'2023-09-18',
			'2023-09-23',
			'2023-10-09',
			'2023-11-03',
			'2023-11-23',
			'2023-12-30',
			'2023-12-31',
		];

		for (let i in others) {
			if (others[i] === date) {
				return true;
			}
		}

		return holiday.between(new Date(date), new Date(date)).length > 0;
	}
}

export default Utils
